<template>
  <div class="contact-content">
    <div class="title">让我们携手合作，共创未来</div>
    <div class="us-contain">
      <div class="us-row" v-for="(item, index) in list" :key="index">
        <div class="us-lt">
          <div class="us-lt-row">
            <div class="lt-item">
              <div class="lt-item-round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="16"
                  viewBox="0 0 12 16"
                  fill="none"
                  class="svg-img"
                >
                  <path
                    d="M5.99998 16C5.99998 16 0 9.31347 0 5.99999C0 2.6866 2.68651 0 5.99998 0C9.31352 0 12 2.68662 12 5.99999C12 9.31345 5.99998 16 5.99998 16ZM5.99998 3.73443C4.74881 3.73443 3.73436 4.74889 3.73436 6.00004C3.73436 7.25127 4.74881 8.2657 5.99998 8.2657C7.25119 8.2657 8.26562 7.25127 8.26562 6.00004C8.26562 4.74889 7.25119 3.73443 5.99998 3.73443Z"
                    fill="#1B56A9"
                  />
                </svg>
              </div>
              <div class="lt-item-column">
                <div class="name">{{ item.areaName }}</div>
                <div class="message">
                  {{ item.address }}
                </div>
              </div>
            </div>
          </div>
          <div class="us-lt-row">
            <div class="lt-item">
              <div class="lt-item-round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  class="svg-img"
                >
                  <path
                    d="M7.00058 7.80507C7.50628 7.80507 8.00704 7.70413 8.47425 7.50801C8.94146 7.31189 9.36598 7.02443 9.72357 6.66204C10.0812 6.29966 10.3648 5.86945 10.5583 5.39597C10.7519 4.92249 10.8515 4.41502 10.8515 3.90254C10.8515 3.39005 10.7519 2.88258 10.5583 2.4091C10.3648 1.93562 10.0812 1.50541 9.72357 1.14303C9.36598 0.780642 8.94146 0.493184 8.47425 0.297063C8.00704 0.100942 7.50628 -7.63667e-09 7.00058 0C5.97926 1.5423e-08 4.99977 0.411159 4.27759 1.14303C3.55541 1.87489 3.14969 2.86752 3.14969 3.90254C3.14969 4.93755 3.55541 5.93018 4.27759 6.66204C4.99977 7.39391 5.97926 7.80507 7.00058 7.80507ZM7.00058 9.75663C3.14218 9.75663 1.58995e-05 12.379 1.58995e-05 15.6101C-0.000446652 15.6615 0.00918758 15.7124 0.028356 15.7599C0.0475244 15.8074 0.0758424 15.8506 0.111656 15.8868C0.14747 15.9231 0.190061 15.9518 0.236942 15.9713C0.283823 15.9907 0.334054 16.0005 0.3847 16H13.6153C13.6659 16.0005 13.7162 15.9907 13.7631 15.9713C13.8099 15.9518 13.8525 15.9231 13.8883 15.8868C13.9242 15.8506 13.9525 15.8074 13.9716 15.7599C13.9908 15.7124 14.0004 15.6615 14 15.6101C14 12.379 10.8578 9.75663 6.99942 9.75663H7.00058Z"
                    fill="#1B56A9"
                  />
                </svg>
              </div>
              <div class="lt-item-column">
                <div class="name">{{ item.contactPerson }}</div>
                <div class="message">联系人</div>
              </div>
            </div>
            <div class="lt-item">
              <div class="lt-item-round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="13"
                  viewBox="0 0 16 13"
                  fill="none"
                  class="svg-img"
                >
                  <path
                    d="M8.00004 4.8124C9.54109 4.8124 10.8768 5.13177 11.9732 5.76145C12.8607 6.27136 13.5893 6.98088 14.1375 7.87186C15.0643 9.378 15.1571 10.8714 15.1589 10.9331C15.1893 11.4812 15.0036 12.0001 14.6393 12.3921C14.275 12.7841 13.7768 13 13.2357 13H2.76258C2.2233 13 1.7233 12.7841 1.35902 12.3921C0.994737 12.0001 0.809021 11.4812 0.839378 10.9331C0.84295 10.8696 0.934022 9.37618 1.86258 7.87186C2.41258 6.98088 3.14115 6.27136 4.02685 5.76145C5.12327 5.13177 6.45898 4.8124 8.00004 4.8124ZM8.00004 6.451C6.66791 6.45101 5.58398 7.5543 5.58398 8.90801C5.58398 10.2617 6.66791 11.3632 8.00004 11.3632C9.33217 11.3632 10.4161 10.2635 10.4161 8.90801C10.4161 7.55248 9.33217 6.451 8.00004 6.451ZM8.00004 7.2694C8.88931 7.2694 9.61074 8.00433 9.61074 8.9062C9.61074 9.80807 8.88931 10.543 8.00004 10.543C7.11255 10.543 6.38934 9.80988 6.38933 8.9062C6.38933 8.00433 7.11076 7.26941 8.00004 7.2694ZM7.96432 0C9.41788 0 10.8536 0.221389 12.1196 0.638749C13.4928 1.09422 14.6107 1.75294 15.441 2.59855C16.2857 3.45868 16.0768 4.59827 15.4518 5.2352C15.2446 5.44569 14.8875 5.54732 14.3607 5.54732C13.5232 5.54731 12.0018 5.24064 11.5286 4.75977C11.2375 4.46399 11.1697 4.0938 11.1143 3.7962C11.0447 3.42965 11.0036 3.32077 10.8464 3.25181C10.1197 2.93426 9.07681 2.75279 7.98575 2.75279C6.9072 2.75279 5.87505 2.93244 5.1572 3.24456C5.00007 3.3117 4.95899 3.42059 4.89292 3.78713C4.83756 4.08654 4.7697 4.45854 4.48042 4.75251C4.21613 5.02107 3.66257 5.20617 3.24472 5.31323C2.70544 5.45114 2.12865 5.53099 1.66259 5.53099C1.12689 5.53099 0.766162 5.42755 0.557237 5.21524C0.24296 4.89405 0.0411697 4.45672 0.00545608 4.01396C-0.0231146 3.64015 0.046537 3.08668 0.553666 2.57133C1.37687 1.73479 2.48402 1.08152 3.84471 0.633305C5.09648 0.217757 6.52148 1.9972e-06 7.96432 0Z"
                    fill="#1B56A9"
                  />
                </svg>
              </div>
              <div class="lt-item-column">
                <div class="name">联系电话</div>
                <div class="message">{{ item.contactNumber || '--' }}</div>
              </div>
            </div>
          </div>
          <div class="us-lt-row">
            <div class="lt-item">
              <div class="lt-item-round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="13"
                  viewBox="0 0 16 13"
                  fill="none"
                  class="svg-img"
                >
                  <path
                    d="M1.60019 0H14.3998C15.273 0 15.9889 0.721265 16 1.60515L8.00277 6.14511L0.00739973 1.61089C0.0147994 0.723179 0.725171 0 1.60019 0ZM0.00739973 3.34805L0 11.3757C0 12.2692 0.719621 13 1.60019 13H14.3998C15.2804 13 16 12.2692 16 11.3757V3.34422L8.19147 7.67182C8.07122 7.73878 7.92693 7.73878 7.80853 7.67182L0.00739973 3.34805Z"
                    fill="#1B56A9"
                  />
                </svg>
              </div>
              <div class="lt-item-column">
                <div class="name">电子邮箱</div>
                <div class="message">{{ item.email || '--' }}</div>
              </div>
            </div>
            <div class="lt-item">
              <div class="lt-item-round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  class="svg-img"
                >
                  <path
                    d="M3.37797 18H3.47118C5.6048 17.8885 8.48747 15.8553 11.182 12.5576L12.1768 11.3394C14.8714 8.0469 16.2831 4.82642 15.9526 2.72805C15.7221 1.24907 13.5478 0 12.3073 0C11.6972 0 11.4735 0.308836 11.3973 0.492422C10.694 1.75693 9.82458 3.95482 9.82119 4.74407V4.79897L9.83983 4.85044C9.99574 5.26566 10.3415 5.46468 10.6482 5.63969C11.0515 5.87132 11.2803 6.02231 11.3091 6.45811C11.3159 6.59022 11.2041 7.19245 9.42633 9.40921L8.66541 10.3391C6.88259 12.4684 6.32334 12.6983 6.19116 12.7172C5.76071 12.7772 5.55904 12.5868 5.2506 12.2436C5.01335 11.9828 4.74728 11.686 4.30666 11.6208L4.25074 11.6122L4.19651 11.6243C3.42034 11.7907 1.43416 13.0878 0.305491 14.0503C0.142801 14.1584 -0.141907 14.4844 0.0834866 15.2016C0.435983 16.3289 1.97476 18 3.37797 18Z"
                    fill="#1B56A9"
                  />
                </svg>
              </div>
              <div class="lt-item-column">
                <div class="name">手机号</div>
                <div class="message">{{ item.phone || '--' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="us-rt">
          <div class="map" :id="'map' + index"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanyContactList } from '@/api/home/home'
export default {
  name: 'ContactUs',
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getTimelineList()
  },
  methods: {
    getTimelineList() {
      getCompanyContactList().then((res) => {
        this.list = res.data
        this.$nextTick(() => {
          this.initMap()
        })
      })
    },
    initMap() {
      //设置一个默认的中心点
      this.list.forEach((item, index) => {
        const center = new window.TMap.LatLng(item.latitude, item.longitude)
        //初始化地图
        var map = new window.TMap.Map(document.getElementById('map' + index), {
          center: center, //设置地图中心点坐标
          zoom: 16 //设置地图缩放级别
          // pitch: 43.5,  //设置俯仰角
          // rotation: 45    //设置地图旋转角度
        })
        //设定marker点及其样式
        const markerLayer = new window.TMap.MultiMarker({
          map: map, //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            myStyle: new window.TMap.MarkerStyle({
              width: 25, // 点标记样式宽度（像素）
              height: 35 // 点标记样式高度（像素）
              // "src": './images/R-C.png',  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": { x: 16, y: 32 }  //marker点图片跟据焦点位置的偏移量
            })
          },
          //点标记数据数组
          geometries: [
            {
              id: index + 1 + '', //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              styleId: 'myStyle', //指定样式id
              position: new window.TMap.LatLng(item.latitude, item.longitude), //点标记坐标位置
              properties: {
                //自定义属性
                title: '地址：'
              }
            }
          ]
          // 点标记数组格式
          //   geometries: [
          //     {
          //     "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          //     "styleId": 'myStyle',  //指定样式id
          //     "position": new window.TMap.LatLng(24.638627, 118.073705),  //点标记坐标位置
          //     "properties": {//自定义属性
          //       "title": "荆州万达广场",
          //     }
          //   }
          // ]
        })

        //设置信息窗口
        var infoWindow = new window.TMap.InfoWindow({
          map: map,
          position: new window.TMap.LatLng(24.628959, 118.064711), //信息窗口默认位置
          offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
        })

        //信息窗口设置完后默认是打开的 可以先关闭初始信息窗口
        infoWindow.close()
        //监听marker点击事件
        markerLayer.on('click', function (evt) {
          infoWindow.open() // 打开信息窗
          infoWindow.setPosition(evt.geometry.position) // 设置信息窗位置
          infoWindow.setContent(
            `<div id="infoPopup" stationId="${evt.geometry.id}" style="cursor: pointer;min-width: 300px;display:flex;justify-content: space-between;align-items: center;"><div style="display:flex;flex-direction: column;align-items: flex-start;padding: 0 14px;font-size: 16px;line-height: 2em;">
          <div>${evt.geometry.properties.title}</div><div style="color: #666;"> 福建省厦门市集美区后溪镇珩圣路386号226室
        
        </div></div>
         
          </div>`
          ) // 设置信息窗内容
          document
            .querySelector('#infoPopup')
            .addEventListener('click', function () {})
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.contact-content {
  display: flex;
  flex-direction: column;
  width: 1472px;
  margin: 96px auto 120px;
  .us-contain {
    display: flex;
    flex-direction: column;
    .us-row {
      display: flex;
      flex-direction: row;
      margin: 46px 64px 0;
      .us-rt {
        width: 580px;
        height: 208px;
        margin: auto 0;
        margin-left: 78px;
        .map {
          width: 580px;
          height: 208px;
        }
      }
      .us-lt {
        display: flex;
        flex-direction: column;
        flex: 1;
        .us-lt-row {
          display: flex;
          flex-direction: row;
          gap: 16px;
          margin-bottom: 34px;
          .lt-item {
            display: flex;
            flex-direction: row;
            flex: 1;

            .lt-item-column {
              display: flex;
              flex-direction: column;
              flex: 1;
              margin-left: 16px;
              .message {
                height: 24px;
                line-height: 24px;
                margin-top: 4px;
                color: #4e5969;
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              .name {
                height: 28px;
                line-height: 28px;
                color: #1d2129;
                font-size: 18px;
                font-weight: 600;
              }
            }
            .lt-item-round {
              border-radius: 8px;
              border: 0 solid #e5e7eb;
              background: rgba(27, 86, 169, 0.1);
              width: 48px;
              height: 48px;
              text-align: center;
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin: auto 0;
              .svg-img {
                width: 16px;
                height: 16px;
                object-fit: contain;
                margin: auto;
              }
            }
          }
        }
        .us-lt-row:last-child {
          margin-bottom: 0 !important;
        }
      }
    }
    .us-row:nth-child(n + 2) {
      margin-top: 80px;
    }
  }
  .title {
    color: #111;
    font-size: 40px;
    font-weight: 600;
    line-height: 60px;
    margin-top: 16px;
  }
  .title-btn {
    border-radius: 9999px;
    border: 0 solid #e5e7eb;
    background: rgba(27, 86, 169, 0.1);
    width: 88px;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    color: #1b56a9;
    font-size: 14px;
    font-weight: 500;
  }
}

// 手机端css
.mobile-content {
  .contact-content {
    width: 345px;
    margin: 32px auto 60px;
    .us-contain {
      .us-row {
        display: flex;
        flex-direction: column;
        margin: 32px 0 0;
        .us-rt {
          width: 345px;
          height: 200px;
          margin: 20px 0 0;
          .map {
            width: 345px;
            height: 200px;
          }
        }
        .us-lt {
          .us-lt-row {
            gap: 10px;
            margin-bottom: 20px;
            .lt-item {
              .lt-item-column {
                margin-left: 10px;
                .message {
                  height: 21px;
                  line-height: 21px;
                  font-size: 12px;
                  margin-top: 3px;
                }
                .name {
                  height: 24px;
                  line-height: 24px;
                  font-size: 14px;
                }
              }
              .lt-item-round {
                width: 35px;
                height: 35px;
                .svg-img {
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }
        }
      }
    }
    .title {
      font-size: 24px;
      line-height: 35px;
      height: auto;
      width: 345px;
      margin: 20px auto 0;
      text-align: center;
    }
    .title-btn {
      margin: 0 auto;
    }
  }
}
</style>
